
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
export default{
components: {
Flexbox,
FlexboxItem,
Icon,
XButton ,
Alert ,
Group,
Confirm,
loadPage
},directives: {
TransferDom
},
beforeMount(){
this.show_1 = true;
this.width = window.screen.width - 10;
/*正式环境*/

/*测试环境*/
let url = global.host + 'clientHouse/getClientHouseByUser?phone=' + this.$router.history.current.query.phone;
this.$http.get(url).then(function(res){
console.log(res)
if(res.body.result){
let data= res.body.result;
for(let i = 0; i < data.length ; i++){
this.list.push(data[i])
}
}
this.show_1 = false;
},function(err){
console.log(err)
})
},
data(){
return{
list:[],
currentIndex:0,
width:'',
alertTitle:'温馨提示',
alertContent:'',
showAlert:false,
showconfirm:false,
currentIndex:''
}
},
mounted(){
if(this.$router.history.current.path == "/changeHouse"){
document.title = "我的房产";
}
},
methods:{
/*用户切换房屋后更新数据重新渲染数据*/
onHide(){
this.showAlert = false;
this.resetData()
},
confirmCancel(index){
this.showconfirm = true;
this.currentIndex = index;
},
/*房屋解绑*/
houseUnbind(){
let data = this.list[this.currentIndex];
let url = global.host + "users/Unbind?id=" +  data.id + "&phone=" + this.$router.history.current.query.phone;
this.$http.delete(url).then(function(res){
console.log(res)
if(res.body.success == true){
this.alertContent = '房屋解绑成功'
this.showAlert = true;
}else{
if(res.body.statusCode == 120){
this.alertContent = '房屋解绑异常'
this.showAlert = true;
}else{
this.alertContent = '房屋解绑成功'
this.showAlert = true;
}
}
},function(err){
console.log(err)
})
},

addHouse(){
this.$router.push({path:'/houseBind',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone,IsDefault:0}})
},
submitChange(index){
this.currentIndex = index;
/*修改数据所有的为0 要修改的为1*/
for(let i = 0 ; i < this.list.length ; i++){
this.list[i].isDefault = 0;
}
this.list[this.currentIndex].isDefault = 1;
let url = global.host + 'clientHouse/updateClientHouseStatus';
this.$http.post(url,this.list).then(function(res){
if(res.body.success){
this.resetData();
}
},function(err){
console.log(err)
})
},
/*用户切换房屋后更新数据*/
resetData(){
let url = global.host + 'clientHouse/getClientHouseByUser?phone=' + this.$router.history.current.query.phone;
this.$http.get(url).then(function(res){
let size = this.list.length;
for(let i= 0 ; i < size ; i++){
this.list.pop();
}
if(res.body.result){
let data= res.body.result;
for(let i = 0; i < data.length ; i++){
this.list.push(data[i])
}
}
},function(err){
console.log(err)
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/userComponents/changeHouse.vue